import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {useNavigate, useParams} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Select from "react-select";
import {BiSolidSelectMultiple} from "react-icons/bi";
import EmptyPic from "../../Assets/Images/emptypic.png";
import {LiaUserEditSolid} from "react-icons/lia";


const currencyFormat = Intl.NumberFormat('en-US');


function EditProduct() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [, setGroups] = React.useState([]);
    const [name, setName] = React.useState('');
    const [brief, setBrief] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [inboxCount, setInboxCount] = React.useState(0);
    const [price, setPrice] = React.useState(0);
    const [discountPercent, setDiscountPercent] = React.useState(0);
    const [consumerPrice, setConsumerPrice] = React.useState(0);
    const [wholesaleAmount, setWholesaleAmount] = React.useState(0);
    const [wholesalePercent, setWholesalePercent] = React.useState(0);
    const [taxPercent, setTaxPercent] = React.useState(0);
    const [unitId, setUnitId] = React.useState(0);
    const [countUnits, setCountUnits] = React.useState([]);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState();
    const [isActive, setIsActive] = React.useState(0);
    const [eachPrice, setEachPrice] = React.useState(0);
    const [photo, setPhoto] = React.useState(null);
    const [filePhoto, setFilePhoto] = React.useState(null);
    const [picPhoto, setPicPhoto] = React.useState(EmptyPic);
    const [unit, setUnit] = React.useState('');


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


        API.getCountUnit()
            .then((response) => {
                setCountUnits(response.data.count_units);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        const param = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor")
        }

        API.getProduct(param, id)
            .then((response) => {

                setName(response.data.name);
                setInboxCount(response.data.in_box_count);
                setBrief(response.data.brief);
                setUnit(response.data.unit);
                setIsActive(response.data.is_active);
                setUnitId(response.data.counting_unit?.id)
                setDescription(response.data.description);
                setPrice(response.data.vendor_price.price);
                setEachPrice(response.data.vendor_price.each_price);
                setDiscountPercent(response.data.vendor_price.discount_percent);
                setTaxPercent(response.data.tax_percent);
                setConsumerPrice(response.data.vendor_price.consumer_price);
                setWholesaleAmount(response.data.vendor_price.wholesale_amount);
                setWholesalePercent(response.data.vendor_price.wholesale_percent);
                setPhoto(response.data.cover_image)
                let groupId = response.data.group
                const params = {
                    count: 2000,
                    for_suppliers: 1
                }

                API.getProductGroups(params)
                    .then((response) => {
                        setGroups(response.data);
                        const groups = response.data;
                        let options = [];
                        for (let data in groups) {
                            if (groups[data].id === groupId) {
                                setSelectedOptions({
                                    value: groups[data].id,
                                    label: groups[data].name,
                                })
                            }
                            options.push({
                                value: groups[data].id,
                                label: groups[data].name,
                            })
                        }
                        setSelectOptions(options)
                        setIsLoaded(true);
                    })
                    .catch((error) => {
                        if (error.response) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    });
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, [id]);

    const onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicPhoto(reader.result);
            setFilePhoto(event.target.files[0])
        };
    }

    const onClickSaveButton = () => {
        setIsLoaded(false);

        const formData = new FormData();
        if (filePhoto)
            formData.append('photo', filePhoto);

        formData.append('name', name);
        formData.append('description', description);
        formData.append('brief', brief);
        formData.append('price', price);
        formData.append('in_box_count', inboxCount);
        formData.append('tax_percent', taxPercent);
        formData.append('group_id', selectedOptions.value);
        formData.append('is_active', isActive);
        formData.append('counting_unit_id', unitId);
        formData.append('each_price', eachPrice);
        formData.append('unit', unit);

        formData.append('consumer_price', consumerPrice);
        formData.append('wholesale_percent', wholesalePercent);
        formData.append('discount_percent', discountPercent);
        formData.append('wholesale_amount', wholesaleAmount);
        formData.append('vendor_id', window.localStorage.getItem("vendor"));

        API.updateProduct(formData, id)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
                navigate(`/products`)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                     <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                         id='active'
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 product-form main-part mt-md-5">
                        <div className="row">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                                مدیریت اطلاعات کالا
                            </div>
                            <div className="col-md-8 ">

                                <img alt="Pic"
                                     src={(photo && !filePhoto) ? photo : picPhoto}
                                     width={140} className='rounded'/>
                                <span className="px-md-5 px-2">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر جدید
                                                 <input type="file" onChange={onFileChange}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-md-4 mt-3 px-5  p-2  ">
                                <div className="form-check form-switch ">
                                    <label className="form-check-label mx-4">
                                        نمایش داده شود؟
                                    </label>
                                    <input type="checkbox"
                                           className="form-check-input" role="switch"
                                           id="flexSwitchCheckDefault"
                                           checked={isActive}
                                           value={1}
                                           onChange={() => {
                                               setIsActive(1 - isActive)
                                           }}
                                    />
                                </div>


                            </div>
                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    نام کالا
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={name}
                                           onChange={
                                               (event) => {
                                                   setName(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>

                            {/*     <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    توضیحات مختصر
                                </label>
                                <div className="form-floating mb-3">

                                    <textarea
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={brief}
                                        onChange={
                                            (event) => {
                                                setBrief(event.target.value)
                                            }
                                        }
                                    >
                                    </textarea>

                                </div>
                            </div>*/}
                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    انتخاب گروه کالا
                                </label>
                                <div className="form-floating mb-3">
                                    <Select
                                        options={selectOptions}
                                        placeholder="گروه کالا"
                                        value={selectedOptions}
                                        isSearchable={true}
                                        onChange={
                                            (event) => {
                                                setSelectedOptions(event)
                                            }
                                        }
                                    />


                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    انتخاب واحد شمارش کالا (بسته)
                                </label>
                                <div className="form-floating mb-3">
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={unitId}
                                        onChange={
                                            (event) => {
                                                setUnitId(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                            انتخاب واحد شمارش
                                        </option>
                                        {
                                            isLoaded && countUnits.map(unit => {
                                                return (
                                                    <option value={unit.id} key={unit.id}>
                                                        {unit.title}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    تعداد در بسته
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={inboxCount}
                                           onChange={
                                               (event) => {
                                                   setInboxCount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    عنوان واحد کالا
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={unit}
                                           onChange={
                                               (event) => {
                                                   setUnit(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="floatingInput">
                                    توضیحات
                                </label>
                                <div className="form-floating mb-3">
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت مصرف کننده (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={consumerPrice}
                                           onChange={
                                               (event) => {
                                                   setConsumerPrice(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(consumerPrice / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت هر عدد (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={eachPrice}
                                           onChange={
                                               (event) => {
                                                   setEachPrice(event.target.value)
                                                   setPrice(event.target.value * inboxCount)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(eachPrice / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت پایه (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={price}
                                           onChange={
                                               (event) => {
                                                   setPrice(event.target.value)
                                                   setEachPrice(Math.round(event.target.value / inboxCount))
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف پایه
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={discountPercent}
                                           onChange={
                                               (event) => {
                                                   setDiscountPercent(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price * (100 - discountPercent) / 1000))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد مالیات
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={taxPercent}
                                           onChange={
                                               (event) => {
                                                   setTaxPercent(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>*/}

                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    حد آستانه تخفیف حجمی
                                </label>
                                <div className="form-floating ">
                                    <input type="number"
                                           className="form-control text-center text-small-1 ltr"
                                           id="floatingInput"

                                           value={wholesaleAmount}
                                           onChange={
                                               (event) => {
                                                   setWholesaleAmount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <p className='text-small-3 text-center text-secondary opacity-50 mt-0 ltr'>
                                    برای عدم محاسبه 1- وارد کنید
                                </p>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف خرید حجمی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={wholesalePercent}
                                           onChange={
                                               (event) => {
                                                   setWholesalePercent(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price * (100 - wholesalePercent) / 1000))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 mt-1">
                                &nbsp;
                            </div>
                            <div className="col-md-6 mt-3">
                                &nbsp;
                            </div>
                            <div className="col-md-6 mt-3">


                                <button className='btn btn-success w-100'
                                        onClick={onClickSaveButton}
                                        disabled={!isLoaded}
                                >
                                    {isLoaded ?
                                        'به روز رسانی اطلاعات' : 'در حال به روز رسانی'
                                    }
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default EditProduct;